module.exports = __webpack_public_path__ + "media/images/user/logo_portal-40d9fb53d197a1b0b4b49ed23ab2caea.svg";